import { render, staticRenderFns } from "./Dashboard-T.vue?vue&type=template&id=23253066&"
import script from "./Dashboard-T.vue?vue&type=script&lang=js&"
export * from "./Dashboard-T.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard-T.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports